export function queryStringParser<T>(arg: T): string {
  const payload = arg as { [key: string]: string };
  const keys = Object.keys(payload);
  const url = keys.reduce((acc, curr) => {
    acc += `${curr}=${payload[curr]}&`;
    return acc;
  }, "");
  return url;
}
